<mat-toolbar class="dashbg">
    <div>
        <a mat-icon-button (click)="clickBack()">
            <mat-icon>keyboard_arrow_left</mat-icon>
        </a>
        <span>{{db.itemsFiltered.length}} Deals</span>
    </div>
    <div>
        <profile></profile>
    </div>
</mat-toolbar>
<div class="toolbartop"></div>


<div class="main-container-flex split s20" *ngIf="db.auth.profile?.values">
    <div class="main">


        <mat-spinner *ngIf="!db.loaded" [strokeWidth]="5"></mat-spinner>


        <div style="height: 200px; padding-bottom:5px;">
            <ngx-charts-bar-vertical-stacked [results]="stats.statChart" [gradient]="gradient" [xAxis]="showXAxis"
                [yAxis]="showYAxis" [legend]="showLegend" [showXAxisLabel]="showLegend" [showYAxisLabel]="showLegend"
                [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel" [animations]="animations"
                [customColors]="customColors">
            </ngx-charts-bar-vertical-stacked>
        </div>


        <div style="overflow-y: auto; height: calc(100vh - 300px);">
            <table mat-table [dataSource]="db.itemsFilteredOrdered" class="mat-elevation-z8">

                <ng-container matColumnDef="icon">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element">
                        <mat-icon matListIcon [matTooltip]="element.type | param:'actionTypes'" color="primary">{{element.icon}}</mat-icon>
                    </td>
                </ng-container>

                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef>Date</th>
                    <td mat-cell *matCellDef="let element"> {{element.date?.toDate() | date:'dd MMM yyyy'}} </td>
                </ng-container>

                <ng-container matColumnDef="amount">
                    <th mat-header-cell *matHeaderCellDef>Amount</th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.budget}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="projectRealtor">
                    <th mat-header-cell *matHeaderCellDef> </th>
                    <td mat-cell *matCellDef="let element">
                        <img mat-card-avatar [src]="element.project?.realtor | realtor"
                            [matTooltip]="element.project?.realtor | realtorName" />
                    </td>
                </ng-container>

                <ng-container matColumnDef="project">
                    <th mat-header-cell *matHeaderCellDef>Project</th>
                    <td mat-cell *matCellDef="let element">
                        <ng-container *ngIf="element.project">
                            <div>C{{ element.project.ref }}</div>
                            <ng-container *ngIf="element.project.contactsProjects">
                                <div *ngFor="let contactProject of element.project.contactsProjects">
                                    {{ contactProject }}
                            </div>
                        </ng-container>
                            <div>{{ element.projectCADisplay }}</div>
                        </ng-container>
                    </td>
                </ng-container>

                <!-- <ng-container matColumnDef="projectCA">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element">
                    {{ element.projectCADisplay }}
                </td>
            </ng-container> -->

                <ng-container matColumnDef="mandateRealtor">
                    <th mat-header-cell *matHeaderCellDef> </th>
                    <td mat-cell *matCellDef="let element">
                        <img mat-card-avatar [src]="element.mandate?.realtor | realtor"
                            [matTooltip]="element.mandate?.realtor | realtorName" />
                    </td>
                </ng-container>

                <ng-container matColumnDef="mandate">
                    <th mat-header-cell *matHeaderCellDef>Mandate</th>
                    <td mat-cell *matCellDef="let element">
                        <ng-container *ngIf="element.mandate">
                            <div>{{ this.setting.prefixMandate + element.mandate.ref }}</div>
                            <ng-container *ngIf="element.mandate.owners">
                                <div *ngFor="let owner of element.mandate.owners">
                                    {{ owner }}
                            </div>
                        </ng-container>
                            <div>{{ element.mandateCADisplay }}</div>
                        </ng-container>
                    </td>
                </ng-container>

                <!-- <ng-container matColumnDef="mandateCA">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element">
                    
                </td>
            </ng-container> -->

                <ng-container matColumnDef="totalCA">
                    <th mat-header-cell *matHeaderCellDef> </th>
                    <td mat-cell *matCellDef="let element">
                    <div><b>{{element.cy | param:'cies'}} {{ calculTotal(element) | number }}</b></div>
                    <div *ngIf="element.cy !== 'mur'"
                        [matTooltip]="'Currency Rate: ' + element.xrate"
                        [matTooltipDisabled]="element.cy === 'mur'">
                        <i>Rs {{calculTotal(element, true) | number }}</i>
                    </div>
                    </td>
                </ng-container>

                <tr mat-header-row
                    *matHeaderRowDef="['icon', 'date', 'amount', 'projectRealtor', 'project',  'mandateRealtor', 'mandate','totalCA']; sticky: true">
                </tr>
                <tr mat-row
                    *matRowDef="let row; let element; columns: ['icon', 'date', 'amount', 'projectRealtor', 'project', 'mandateRealtor', 'mandate','totalCA'];"
                    (click)="goItem(element)">
                </tr>
            </table>
        </div>
    </div>
    <div class="side">
        <form [formGroup]="sortServerForm" novalidate>

            <mat-form-field appearance="fill">
                <mat-label>Year</mat-label>
                <mat-select formControlName="year">
                    <mat-option *ngFor="let year of years" [value]="year">
                        {{year}}
                    </mat-option>
                </mat-select>
            </mat-form-field>


            <mat-form-field formGroupName="arrayFilters" appearance="fill" *ngIf="!db.isRole('realtor') && db.auth.profile?.values?.agencies?.length > 1">
                <mat-label>Agency</mat-label>
                <mat-select formControlName="agencies">
                    <mat-option *ngFor="let param of 'userAgencies' | params" [value]="param.id">
                        {{param.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

        </form>

        <form [formGroup]="sortLocalForm" novalidate>

            <mat-form-field formGroupName="arrayFilters" appearance="fill"
                *ngIf="sortServerForm.controls['arrayFilters'].value?.agencies">
                <mat-label>Realtor</mat-label>
                <mat-select formControlName="realtors">
                    <mat-option value="">
                        All Agents
                    </mat-option>
                    <ng-container>
                        <mat-option
                            *ngFor="let param of setting.realtorsAgency[sortServerForm.controls['arrayFilters'].value?.agencies]"
                            [value]="param.id">
                            {{param.name}}
                        </mat-option>
                    </ng-container>
                </mat-select>
            </mat-form-field>
        </form>
    </div>
</div>